module.exports = __webpack_public_path__ + "img/sport_master.1b231b96.png";